// Load Helpers first - needed by other components (mergeDeep, etc.)
import "./components/Helpers";
import ComponentLoader from "./components/ComponentLoader";
// Flag icons CSS is now imported in plugins.scss to ensure proper webpack processing

document.addEventListener('DOMContentLoaded', () => {
	let defaultThemeMode = "dark";
	let themeMode;

	if (document.documentElement) {
		if (document.documentElement.hasAttribute("data-bs-theme-mode")) {
			themeMode = document.documentElement.getAttribute("data-bs-theme-mode");
		} else {
			if (localStorage.getItem("data-bs-theme") !== null) {
				themeMode = localStorage.getItem("data-bs-theme");
			} else {
				themeMode = defaultThemeMode;
			}
		}
		if (themeMode === "system") {
			themeMode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
		}
		document.documentElement.setAttribute("data-bs-theme", themeMode);
	}

	new ComponentLoader();
});

window.addEventListener('hide.bs.modal', () => {
	if (document.activeElement instanceof HTMLElement) {
		document.activeElement.blur();
	}
});
